export const collaboratorsData = [
  {
    id: 1,
    img: "",
    writtenBy: "Shanti and Mayank",
    writterPosition: "Lead Writer",
    forBio: "Lead Writer | Personal finance, Personal loans",
    forBioPara:
      "Ronita Choudhuri-Wade is a former NerdWallet writer covering personal loans. Before joining NerdWallet, Ronita was a freelance writer for the fintech company Wise (formerly TransferWise) on global money transfers and banking internationally. She was previously a senior internal wholesaler at MainStay Investments, holding her Series 6, 65, 63 and 7 licenses. Ronita graduated from New York University and has a master’s degree in globalization and development from the University of Manchester in the United Kingdom. Ronita currently lives in Tulsa, Oklahoma.",
  },

  {
    id: 2,
    editorImg: "",
    editedBy: "Priya K",
    editorPosition: "Lead Assigning Editor",
    forBio: "Lead Assigning Editor | Consumer lending",
    forBioPara:
      "Kim Lowe is a lead assigning editor on NerdWallet's loans team. She covers consumer borrowing, including topics like personal loans, student loans, buy now, pay later and cash advance apps. She joined NerdWallet in 2016 after 15 years at MSN.com, where she held various content roles including editor-in-chief of the health and food sections. Kim started her career as a writer for print and web publications that covered the mortgage, supermarket and restaurant industries. Kim earned a bachelor's degree in journalism from the University of Iowa and a Master of Business Administration from the University of Washington. She works from her home near Portland, Oregon.",
  },

  {
    id: 3,
    coWriterImg: "",
    coWrittenBy: "Nicole Dow",
    coWritterPosition: "Writer",
    forBio: "Writer",
    forBioPara:
      "Nicole Dow is a freelance writer and editor based in Tampa Bay, Florida. Her work has been featured in The Penny Hoarder and Yahoo Finance, among other outlets. She holds a journalism degree from Hampton University.",
  },
];
